export default __webpack_public_path__ + "static/media/mina.213dcf84.jpg";